import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  formElementContainer: {
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
    width: '100%',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  halfWidthLeftItem: {
    width: '50%',
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  halfWidthRightItem: {
    width: '50%',
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingLeft: 0,
    },
  },
  contactNumContainer: {
    paddingBottom: theme.spacing(1),
  },
  subheader: {
    marginBottom: theme.spacing(6),
  },
  overseasResidence: {
    marginBottom: theme.spacing(4),
  },
  periodOfOverseasResidenceTo: {
    // Custom breakpoint value is defined to ensure that the periodOfOverseasResidenceFrom and periodOfOverseasResidenceTo are vertically aligned.
    [theme.breakpoints.between(699, 735)]: {
      marginTop: theme.spacing(3),
    },
  },
}));
